module.exports = __webpack_public_path__ + "img/colerico.8823cfbb.svg";